import intl from 'react-intl-universal';

export const getTooltipMessage = (
  isTaskProjectDisabled: boolean | undefined,
  canInlineEditTask: boolean | undefined,
  hasPermission: boolean | undefined
) => {
  if (isTaskProjectDisabled) return intl.get('TASKS.PROJECT_DISABLED_TOOLTIP');
  if (!canInlineEditTask && hasPermission)
    return intl.get('TASKS.TASK_DISABLED_OR_HOLD_TOOLTIP');
  if (!hasPermission) return intl.get('TASKS.NO_EDIT_PERMISSION');

  return '';
};
